// Mock data for Fabio Matt Photography Portfolio

export const photographerInfo = {
  name: "Fabio Matt",
  tagline: "Die Welt durch meine Linse",
  bio: "Fotograf mit Leidenschaft für Landschaften, Strassenfotografie und Sportfotografie. Was als Interesse begann, ist zu meiner größten Leidenschaft geworden. Ich liebe es, besondere Momente einzufangen und die Schönheit in alltäglichen Szenen zu entdecken.",
  email: "fabiomatt2005@gmail.com",
  phone: "+423 781 53 06",
  location: "Liechtenstein"
};

export const galleries = {
  landscape: [
    {
      id: 1,
      title: "Kirche in Malta",
      category: "Landschaft",
      image: "/images/landscape/553e52eb-3b5d-4313-b3a4-571791dbfd84.JPG",
      description: "Dramatische Architektur im Süden Europas"
    },
    {
      id: 2,
      title: "Bergbach",
      category: "Landschaft",
      image: "/images/landscape/IMG_0612.JPG",
      description: "Atemberaubender Bergbach im Herzen Österreichst"
    },
    {
      id: 3,
      title: "Alvier Sonnenuntergang",
      category: "Landschaft",
      image: "/images/landscape/_MG_1572.jpg",
      description: "Künstlerische Bergszeene mit dramatischer Silhouette"
    },
    {
      id: 4,
      title: "Winter in Liechtenstein",
      category: "Landschaft",
      image: "/images/landscape/_MG_1195.JPG",
      description: "Die Alpen Liechtensteins im Schnee"
    },
    {
      id: 5,
      title: "Drei Schwestern",
      category: "Landschaft",
      image: "/images/landscape/_MG_1569.jpg",
      description: "Blick auf die Drei Schwestern Kette"
    },
    {
      id: 6,
      title: "Falknis-Gipfel",
      category: "Landschaft",
      image: "/images/landscape/_MG_1613.JPG",
      description: "Blick auf den Falknis"
    },
    {
      id: 7,
      title: "Blick von Tuass ins Rheintal",
      category: "Landschaft",
      image: "/images/landscape/Image.jpg",
      description: "Der Rhein von Vaduz nach Ruggell"
    },
    {
      id: 8,
      title: "Fürstensteig im Winter",
      category: "Landschaft",
      image: "/images/landscape/_MG_0743_2.jpg",
      description: "Jenseits von Gaflei und Triesenberg"
    },
    {
      id: 9,
      title: "Baggerlöcher in Feldkirch",
      category: "Landschaft",
      image: "/images/landscape/_MG_1116.jpg",
      description: "Mit türkisem Wasser"
    }
  ],
  street: [
    {
      id: 10,
      title: "Fernsehturmz",
      category: "street",
      image: "/images/general/_MG_1563-2.JPG",
      description: "In Duisburg, Deutschland"
    },
    {
      id: 11,
      title: "Zeitlose Schönheit",
      category: "street",
      image: "/images/general/_MG_1523-2.JPG",
      description: "Klassisches Gebäude in der Innenstadt"
    },
    {
      id: 12,
      title: "Klassische Uhr",
      category: "street",
      image: "/images/general/_MG_1518.JPG",
      description: "Mit Herbstlichem Vordergrund"
    },
    {
      id: 13,
      title: "Grossstadt",
      category: "street",
      image: "/images/general/_MG_1510.JPG",
      description: "Ein Blick mit Tiefe"
    },
    {
      id: 13,
      title: "Künstlerischer Ausdruck",
      category: "street",
      image: "/images/general/_MG_1487.JPG",
      description: "Auch Industriegegenden können imposant sein"
    },
    {
      id: 15,
      title: "Zeitgenössischer Stil",
      category: "street",
      image: "/images/general/_MG_1470.JPG",
      description: "Ein Arbeitsplatz mit Aussichtt"
    }
  ],
  sports: [
    {
      id: 16,
      title: "Fussball in Bewegung",
      category: "Sport",
      image: "/images/sports/sport1.png",
      description: "Noah Matt, LFV"
    },
    {
      id: 17,
      title: "Dramatische Seitenperspektive",
      category: "Sport",
      image: "/images/sports/sport2.png",
      description: "Noah Matt, LFV"
    },
    {
      id: 18,
      title: "Mannschaft beim Einlauf",
      category: "Sport",
      image: "/images/sports/DSC_0024.PNG",
      description: ""
    },
    {
      id: 19,
      title: "Durchs Tor-Netz",
      category: "Sport",
      image: "images/sports/IMG_1158.PNG",
      description: "Jenseits der Torauslinie"
    }
  ],
  general: [
    {
      id: 20,
      title: "Portrait für Lebenslauf",
      category: "Allgemein",
      image: "/images/portrait/F8BD5FCA-18D7-41AF-A8DB-1F4A982D95F5.JPEG",
      description: "Für Arbeit und Freizeit"
    },
    {
      id: 21,
      title: "Bergsteiger",
      category: "Allgemein",
      image: "/images/portrait/_MG_0765.JPG",
      description: "Mit Steigeisen und Eispickel"
    },
    {
      id: 22,
      title: "Eschner Kirchturm",
      category: "Allgemein",
      image: "/images/portrait/_MG_0589_2.JPG",
      description: "Wo es am schönsten ist."
    },
    {
      id: 22,
      title: "Outdoor Portrait",
      category: "Allgemein",
      image: "/images/portrait/_MG_0503.JPG",
      description: "Am Badesee in Gamprin"
    },
  ]
};

export const getAllPhotos = () => {
  return [
    ...galleries.landscape,
    ...galleries.street,
    ...galleries.sports,
    ...galleries.general
  ];
};

export const getPhotosByCategory = (category) => {
  return galleries[category.toLowerCase()] || [];
};